<template>
  <iframe
    :src="iframeSrc"
    width="100%"
    height="99%"
    style="border: none"
  ></iframe>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['userInfo']),
    userId() {
      // 优先从 userInfo 拿，没有就从 localStorage 拿
      return this.userInfo?.userId || localStorage.getItem('standardUserId') || ''
    },
    iframeSrc() {
      console.log('当前userId:', this.userId)
      const src = `https://hyx.xueduoduo.com/teaching-dev/?userId=${this.userId}&menuType=apply`
      console.log('iframeSrc:', src)
      return src
    }
  }
}
</script>



